import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useRef } from 'react';
import {useGetSupportUsersQuery, useUpdateSupportUserMutation} from '../../features/supportusers/supportusersApiSlice';
import { useGetStoreOfficesQuery } from '../../features/storeoffices/storeofficesApiSlice';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {useGetAssetMastersQuery} from '../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetComplMastersQuery } from '../../features/complmaster/complmasterApiSlice';


const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const MOBILE_REGEX = /^[0]?[789]\d{9}$/;


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />; 

const EditUser =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left:20px;
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #5C5891;
`
const EditFieldButton = styled.button`
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  height: 35px;
  padding: 6px 16px;
  border-radius: 4px;
  border-width: 0;
  background-color: #5C5891;
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
  margin-left: 15px;
  color: #fff;
`
const SubHeadingField = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* margin-left:5px; */
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #5C5891;  
`

const UserEmailWrapper = styled.div`
  margin-left:15px;
  margin-top:20px;
  margin-bottom: 20px;
  min-height: 75px;
`

const LabelInputWrapper = styled.div`
  margin-bottom:25px;
  flex:1 0 30%;
  display: ${(props) => props.disp};
`



const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
`

const Adduserformcont = styled.div`
  display: flex;
  flex-wrap:wrap;
  margin-top:15px;
  margin-bottom: 10px;
`


const EditOptionsWrapper = styled.div`
  display:flex;
  margin-bottom: 20px;
  margin-top:20px;
  margin-left: 30px;
`
const StoreWrapper = styled.div`
  display:flex;
  margin-bottom:20px;
`
const FlexWrapper = styled.div`
  display: flex;
`
const ValidationTextDiv = styled.div`
  color: red;
`
const RoleWrapper = styled.div`
  margin-right:20px;
`
const AssignedCompWrapper = styled.div`
  margin-right:20px;

`
const CompCatWrapper = styled.div`
  margin-right:20px;

`
const RoleCatWrapper = styled.div`
  display:flex;
  margin-top:10px;
  margin-bottom:20px;
`

const Fields = [
  'All',
  'Name',
  'Password',
  'ContactNumber',
  'Store',
  'Roles/Categories',
]

const rolesMAinArray = ["Supervisor", "SupportStaff"];


const EditSupportUsers = () => {
  const initialUserState = {
    id:"",
    supportUser:true,
    name:{firstName:"", middleName:"", lastName:""},
    email:"",
    password: "",
    confirmPassword:"",
    mobileNo:"",
    roles:[], 
    store:"",
    assetCategories:[],
    complaintCategories:[],
    assignedComplaint:[], 
    available:true,
    disabled:false
}
  const userRef = useRef();

  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  const [validFirstName, setValidFirstName] = useState(false);
  const [firstNameFocus, setFirstNameFocus] = useState(false);

  const [validMiddleName, setValidMiddleName] = useState(false);
  const [middleNameFocus, setMiddleNameFocus] = useState(false);

  const [validLastName, setValidLastName] = useState(false);
  const [lastNameFocus, setLastNameFocus] = useState(false);

  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [validMobile, setValidMobile] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);

  const [currentUser, setCurrentUser] = useState(initialUserState);
  const [editFields, setEditFields] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [storeOffices, setStoreOffices] = useState([]);
  const [value, setValue] = useState({});
  const [fieldRender, setFieldRender] = useState(false);
  const [assetMasterData, setAssetMasterData] = useState([]);
  const [complMasterData, setComplMasterData] = useState([]);


  const {supportUser} = useGetSupportUsersQuery("suppuserslist", {
    selectFromResult: ({ data }) => ({
        supportUser: data?.entities
    }),
  })


  const [updateSupportUser, {
    isLoading: updateuserisLoading,
    isSuccess: updateuserisSuccess,
    isError: updateuserisError,
    error: updateuserErrorS
  }] = useUpdateSupportUserMutation();

  
  const {storeoffices}= useGetStoreOfficesQuery("storeoffices", {
    selectFromResult: ({ data }) => ({
      storeoffices: data?.entities
    }),
  })

  const {
    data: assetmasters,
  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const {complmaster} = useGetComplMastersQuery("complList", {
    selectFromResult: ({ data }) => ({
      complmaster: data?.entities
    }),
  })

  useEffect(() => {
    setValidFirstName(USER_REGEX.test(currentUser.name.firstName));
    setValidMiddleName(USER_REGEX.test(currentUser.name.middleName));
    setValidLastName(USER_REGEX.test(currentUser.name.lastName));
  }, [currentUser.name.firstName, currentUser.name.middleName, currentUser.name.lastName ])

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(currentUser.password));
    setValidMatch(currentUser.password === value.confirmpassword);
  }, [currentUser.password, value.confirmpassword])

  useEffect(() => {
    setValidMobile(MOBILE_REGEX.test(currentUser.mobileNo));        
  }, [currentUser.mobileNo]) 
  
  
  const onClickConfirm = (event) => {
    event.preventDefault();
    if(!currentUser?.email?.length) return alert("Please Enter valid email");
    console.log(currentUser)

    let tempUser = structuredClone(currentUser);
    const editUser =  Object.values(supportUser)?.find(x => x.email === currentUser.email);
    for(let key in tempUser){
      tempUser[key] = editUser[key]
    }
    setCurrentUser(tempUser);
    setFieldRender(true);
    alert(`You are editing user ${editUser.name.firstName} ${editUser.name.middleName} ${editUser.name.lastName}`)
  }
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };  

  const onChangeUserForm = (event) =>{
    let tempData = structuredClone(currentUser)
    let tempValue = structuredClone(value);
    if(['firstName', 'middleName', 'lastName'].indexOf(event.target.name) > -1){
      tempData.name[event.target.name] = event.target.value;
      setCurrentUser(tempData)
      return;
    }
    
    if(event.target.name === "confirmpassword"){
      tempValue = {...tempValue,[event.target.name]:event.target.value }
      setValue(tempValue);
      return;
    }
    tempData ={...tempData, [event.target.name]:event.target.value}
    setCurrentUser(tempData);
  }
  
  const onChangeUserForm2 = (event, newValue, name) => {  
    if(name === 'selectFieldsToEdit'){
      setEditFields(newValue)
    }
    if(["store", "roles", "assetCategories", "complaintCategories"].includes(name)){
      let tempUser = structuredClone(currentUser);
      tempUser = {...tempUser, [name]:newValue}
      setCurrentUser(tempUser);
    }
 
    let temp = {...value, [name]:newValue}
    setValue(temp);
  }
  console.log(currentUser)
  
  const onFinalSubmit = async (e) => {
    e.preventDefault();
    console.log(currentUser)
    try{
      let tempUser = structuredClone(currentUser);  
      const result = await updateSupportUser(tempUser);
      console.log(result)
      alert(result.data.message)
      setCurrentUser(initialUserState);
      setFieldRender(false);
      setEditFields([]);
      setValue({})

    } catch (err) {
      console.log(err)
    }

  }
  
const basicInfoArray = ["All", "Name", "Password", "ContactNumber"];

  useEffect(()=>{
    if(storeoffices){
        setStoreOffices(Object.values(storeoffices))
    }
    },[storeoffices])

  useEffect(() =>{
    let tempdata = assetmasters? Object.values(assetmasters?.entities):[];
    setAssetMasterData(tempdata);
    },[assetmasters])

  useEffect(() =>{
    let tempdata = complmaster? Object.values(complmaster):[];
    setComplMasterData(tempdata);
    },[complmaster])

  return (
    <>
    <EditUser>
      <HeadingField>Edit User</HeadingField>
    </EditUser>

    <form onSubmit={onClickConfirm}>    
    <FlexWrapper>
    <UserEmailWrapper>
      <TextField
        id="outlined-basic"
        ref={userRef}
        name='email'
        onChange={(event, newValue) => onChangeUserForm(event, newValue)}
        label="Enter Email"
        value={currentUser?.email}
        variant="outlined"
        onFocus={() => setEmailFocus(true)}
        onBlur={() => setEmailFocus(false)}
        sx={{backgroundColor:"white"}}
      />
      {emailFocus && !validEmail ? <ValidationTextDiv>Please Enter Valid Email</ValidationTextDiv>: null}   
    </UserEmailWrapper>    
    
    <EditOptionsWrapper>
      <Autocomplete
        multiple
        id="selectFieldsToEdit"
        sx={{ minWidth:"200px", maxWidth:"800px"}}
        onChange={(event, newValue) => onChangeUserForm2(event, newValue, 'selectFieldsToEdit')}
        value={editFields}
        options={editFields.includes("All")? ["All"]:Fields}
        disableCloseOnSelect
        getOptionLabel={(option) => option}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
        {option}
        </li>
        )}
        renderInput={(params) => (
      <TextField {...params} label="Select Fields to Edit" placeholder="Edit Fields" />
      )}
      />   
     </EditOptionsWrapper>
     </FlexWrapper>

     
    <EditFieldButton  type='submit'>Confirm</EditFieldButton>
    </form>
    {(fieldRender && editFields?.length) &&
    <form style={{margin:"15px"}} onSubmit={onFinalSubmit}>
    {editFields?.some(x => basicInfoArray.includes(x))  &&
    <SubHeadingField>Basic Info</SubHeadingField>}
    <Adduserformcont>
      { (["Name","All"].some(x => editFields?.includes(x))) && <>
      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='firstName'
          onChange={(event, newValue) => onChangeUserForm(event, newValue)}
          label="First Name"
          value={currentUser?.name?.firstName}
          variant="outlined"
          onFocus={() => setFirstNameFocus(true)}
          onBlur={() => setFirstNameFocus(false)}
          sx={{backgroundColor:"white"}}
        />      
        { firstNameFocus && !validFirstName ? <div>Please Enter Valid First Name</div>:null}
      </LabelInputWrapper>
      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='middleName'
          onChange={(event, newValue) => onChangeUserForm(event, newValue)}
          label="Middle Name"
          value={currentUser?.name?.middleName}
          variant="outlined"
          onFocus={() => setMiddleNameFocus(true)}
          onBlur={() => setMiddleNameFocus(false)}
          sx={{backgroundColor:"white"}}
        />    
        {middleNameFocus && !validMiddleName ? <div>Please Enter Valid Middle Name</div>:null}
      </LabelInputWrapper>

      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='lastName'
          onChange={(event, newValue) => onChangeUserForm(event, newValue)}
          label="Last Name"
          value={currentUser?.name?.lastName}
          variant="outlined"
          onFocus={() => setLastNameFocus(true)}
          onBlur={() => setLastNameFocus(false)}
          sx={{backgroundColor:"white"}}
        />
        {lastNameFocus && !validLastName ? <div>Please Enter Valid Last Name</div>:null}
      </LabelInputWrapper> </>}
            
      {(["Password","All"].some(x => editFields?.includes(x))) && <>
      <LabelInputWrapper>
        <TextField
            id="outlined-basic"
            size='small'
            ref={userRef}
            name='password'
            type={showPassword? "text": "password"}
            onChange={(event, newValue) => onChangeUserForm(event, newValue)}
            label="Password"
            value={currentUser?.password}
            variant="outlined"
            onFocus={() => setPwdFocus(true)}
            onBlur={() => setPwdFocus(false)}
            sx={{backgroundColor:"white"}}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            />               
          {pwdFocus && !validPwd ?<div>Password Error Message</div>:null}
      </LabelInputWrapper>

      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='confirmpassword'
          type='password'
          onChange={(event, newValue) => onChangeUserForm(event, newValue)}
          label="Confirm Password"
          value={value.confirmpassword}
          variant="outlined"
          onFocus={() => setMatchFocus(true)}
          onBlur={() => setMatchFocus(false)}
          sx={{backgroundColor:"white"}}
        />
          {matchFocus && !validMatch? <div>Password Error Message</div>:null}
      </LabelInputWrapper> </>}

      {(["ContactNumber","All"].some(x => editFields?.includes(x))) && 
      <LabelInputWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          ref={userRef}
          name='mobileNo'
          type='text'
          onChange={(event, newValue) => onChangeUserForm(event, newValue)}
          label="Enter Mobile Number"
          value={currentUser.mobileNo}
          variant="outlined"
          onFocus={() => setMobileFocus(true)}
          onBlur={() => setMobileFocus(false)}
          sx={{backgroundColor:"white"}}
          />             
        {mobileFocus && !validMobile ? <div>Enter Valid Mobile Number</div>: null}
      </LabelInputWrapper>            
      }            
      </Adduserformcont>
      {(["Store", "All"].some(x => editFields?.includes(x)))  && <>
      <SubHeadingField>Store</SubHeadingField>            
      <StoreWrapper name="storeWrapper">
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          size='small'
          value={currentUser?.store}
          onChange={(event, newValue) => onChangeUserForm2(event, newValue, "store")}
          options={ storeOffices?.map((item)=>item.storeoffice)}
          sx={{ minWidth: "200px", backgroundColor:"white" }}
          renderInput={(params) => <TextField {...params} label={"Store Office"} />}
        />
    </StoreWrapper>        
  </>}

  {(["Roles/Categories","All"].some(x => editFields?.includes(x)))  && <>
      <SubHeadingField>Roles/Categories</SubHeadingField>            
      <RoleCatWrapper>
        <RoleWrapper name="roles">
          <Autocomplete
            multiple
            id="roles"
            size='small'
            sx={{ minWidth:"200px", maxWidth:"800px", backgroundColor:"white"}}
            onChange={(event, newValue) => onChangeUserForm2(event, newValue, 'roles')}
            value={currentUser.roles}
            options={rolesMAinArray}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
            {option}
            </li>
            )}
            renderInput={(params) => (
          <TextField {...params} label="Select Roles" placeholder="Roles" />
          )}
        /> 
      </RoleWrapper>

      <AssignedCompWrapper name="assignedcomp">
        <Autocomplete
          multiple
          id="roles"
          size='small'
          sx={{ minWidth:"200px", maxWidth:"800px", backgroundColor:"white"}}
          onChange={(event, newValue) => onChangeUserForm2(event, newValue, 'assetCategories')}
          value={currentUser.assetCategories}
          options={assetMasterData.map(x => x.Category)}
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
          {option}
          </li>
          )}
          renderInput={(params) => (
          <TextField {...params} label="Select Asset Categories" placeholder="Asset Categories" />
          )}
        />        
      </AssignedCompWrapper>

      <CompCatWrapper name="complcat">
        <Autocomplete
          multiple
          id="roles"
          size='small'
          sx={{ minWidth:"200px", maxWidth:"800px", backgroundColor:"white"}}
          onChange={(event, newValue) => onChangeUserForm2(event, newValue, 'complaintCategories')}
          value={currentUser.complaintCategories}
          options={complMasterData.filter(elm => currentUser.assetCategories.some(a => elm.ApplAssetCateg.includes(a))).map(x => x.Category)}
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
          {option}
          </li>
          )}
          renderInput={(params) => (
          <TextField {...params} label="Select Complaint Categories" placeholder="Complaint Categories" />
          )}
        />
      </CompCatWrapper>
    </RoleCatWrapper>
  </>}       
      

  <EditFieldButton type='submit' style={{marginLeft:"1px"}} >Final Submit</EditFieldButton>
  </form>}    
  </>
  )
} 

export default EditSupportUsers